import { ArticlePreviewResponse } from "authory-api-types";
import { EmbedTheme } from "../../utils/embeds";
import { getItemDisplayTitle } from "authory-api-types";
import { getThumbnaiPlaceholderIcon } from "../ContentList/ContentList.utils";
import { UnstyledLink } from "../ReusableStyledComponents/UnstyledLink";
import { getItemUrl } from "../V3ProfileList/V3ProfileList.utils";
import { VerticalSpacing } from "../VerticalSpacing";
import { V3EmbedContentListItemImage, V3EmbedContentListItemImageTitle, V3EmbedContentListItemWrapper } from "./V3EmbedContentListitem.styles";
import { CLPlaceholderWrapper } from "../ItemImage/ItemImage.styles";
import { ItemMetadata } from "../ItemMetadata";

interface V3EmbedContentListItemProps {
    item: ArticlePreviewResponse;
    embedTheme: EmbedTheme;
    collectionSlug?: string;
    itemsHref: string;
}

export const V3EmbedContentListItem = ({ item, itemsHref, collectionSlug, embedTheme }: V3EmbedContentListItemProps) => {
    const itemUrl = getItemUrl(item, itemsHref, collectionSlug);

    return (
        <UnstyledLink href={itemUrl} target="_blank">
            <V3EmbedContentListItemWrapper>
                <div>
                    <V3EmbedContentListItemImage $imageSrc={item.thumbnailImage} aria-label={`Preview image of ${item.title}`}>
                        {!item.thumbnailImage && <CLPlaceholderWrapper>{getThumbnaiPlaceholderIcon(item.type)}</CLPlaceholderWrapper>}
                    </V3EmbedContentListItemImage>
                </div>
                <div>
                    <VerticalSpacing bottom={6}>
                        <ItemMetadata
                            item={item}
                            customDateFormat={"MMM dd, yyyy"}
                            showRedirect={false}
                            isEmbed
                            embedTheme={embedTheme}
                            hideFavicon
                        />
                    </VerticalSpacing>
                    <V3EmbedContentListItemImageTitle $numLines={2} $embedTheme={embedTheme}>
                        <strong>{getItemDisplayTitle(item)}</strong>
                    </V3EmbedContentListItemImageTitle>
                </div>
            </V3EmbedContentListItemWrapper>
        </UnstyledLink>
    );
};
